import PropertiesMapView from "./PropertiesMapView";

export default PropertiesMapView;
